import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Importer } from '@feathr/blackbox';
import { Text } from '@feathr/components';

import { hasRunStarted } from './ImportRunDetails.utils';

interface INotStartedLineProps {
  importer: Importer;
}

/** Says that a draft has not been submitted, or that a pending import is waiting to start. */
function NotStartedLine({ importer }: Readonly<INotStartedLineProps>): JSX.Element | null {
  const { t } = useTranslation();

  const state = importer.get('state');
  if (state === 'draft') {
    // Placeholder copy, pending Product and Design (decision 23).
    return <Text.DefaultRegular>{t("This import hasn't been submitted yet.")}</Text.DefaultRegular>;
  }
  if (state === 'pending' && !hasRunStarted(importer)) {
    // Placeholder copy, pending Product and Design (decision 23).
    return <Text.DefaultRegular>{t('This import is waiting to start.')}</Text.DefaultRegular>;
  }
  return null;
}

export default observer(NotStartedLine);
